export default "__VITE_ASSET__18755d2a__"